<template>
<div>
    <el-dialog
    :visible.sync="previewPhotoBoxVisible"
    title="查看照片"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthUploadGuarantee"
    :before-close="close"
    @opened="opened"
  >
    <el-row>
       <el-uploader
       image-viewer
  class="upload-demo"
  strategyKey="1"
  :on-preview="handlePreview"
  :on-remove="handleRemove"
  :file-list="fileList"
  ref="eluploader"
  :disabled="true"
  list-type="picture">
</el-uploader>
    </el-row>
    <el-row>
         <el-row  type="flex"
                  justify="end"
                  align="middle"
                  :gutter="10"
                  class="el-row-margin">
              <el-button
                    type="primary"
                    size="small"
                    @click="batchDownload"
                    plain
                >批量下载
                </el-button
                >
           </el-row>
    </el-row>
  </el-dialog>
            <!-- <template v-if="preview">
      <image-view ref="imageView" :previewSrcList="previewSrcList" :src="src"/>
    </template> -->
    </div>
</template>
<script>
import imageView from "@/views/appointment/imageView"
import { Uploader } from 'ec-light-vue';
import {
  download
} from "@/api/appointment";
export default {
     name: 'previewPhotoBox',
     components: {
         elUploader: Uploader,
         imageView
     },
     data() {
         return {
           src: "",
           showViewer: false,
             fileList: [],
             ebOrderId: ""
         }
     },
     props: {
         previewPhotoBoxVisible: {
             type: Boolean,
             default: false
         },
         fileKey: {
             type: String
         }
     },
     computed: {
       preview() {
        const { previewSrcList } = this;
        return Array.isArray(previewSrcList) && previewSrcList.length > 0;
      },
      previewSrcList() {
        console.log(this.fileList)
        return this.fileList.map(item => item.url)
      }
     },
     active() {
         console.log(this.fileKey)
     },
     watch: {
    //      fileKey: {
    //   handler(newValue, oldValue) {
    //     if(newValue) {
    //         this.$nextTick(() => {
    //             this.ebOrderId = newValue
    //             this.queryPhoto();
    //         })
    //     }
    //   },
    // },
     },
     methods: {
         opened(){
             this.ebOrderId = this.fileKey;
             this.queryPhoto();
         },
         close() {
             this.fileList = [];
             this.fileKey = "";
             this.$emit('update:previewPhotoBoxVisible',false)
         },
         onChange(file, fileList) {

      },
      async queryPhoto() {
          let fileKeyList =  this.ebOrderId.split(',');
          this.fileList = await  Uploader.UploaderStrategy.getFileInfos(fileKeyList);
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
        this.src = file.url
        // don't show viewer when preview is false
        if (!this.preview) {
          return;
        }
        // prevent body scroll
        this.$refs.imageView.clickHandler()

      },
      handleExceed(files, fileList) {
        this.$set(fileList[0], 'raw', files[0]);
        this.$set(fileList[0], 'name', files[0].name);
        this.$refs['upload'].clearFiles();//清除文件
        this.$refs['upload'].handleStart(files[0])
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
       batchDownload() {
         let self = this;
         let url = '/file/batchDownloadByZip';
         if(!this.$parent.currentPhotoPreview.fileKeys) return self.$coreMethods.message("warning", "没有照片不需下载！");
         let searchColumns = new URLSearchParams();
         searchColumns.append(
           "keys",
           this.$parent.currentPhotoPreview.fileKeys
         );
         searchColumns.append(
           "zipName",
           this.$parent.currentPhotoPreview.mblNo + '_' + this.$parent.currentPhotoPreview.hblNo + '_' + this.$parent.currentPhotoPreview.orderNo
         );
         download(url, searchColumns).then(function(response){
           let downloadElement = document.createElement("a");
           let href = window.URL.createObjectURL(response);
           downloadElement.href = href;
           downloadElement.download = self.$parent.currentPhotoPreview.mblNo + '_' + self.$parent.currentPhotoPreview.hblNo + '_' + self.$parent.currentPhotoPreview.orderNo+'.zip'
           document.body.appendChild(downloadElement);
           downloadElement.click();
           document.body.removeChild(downloadElement);
           window.URL.revokeObjectURL(href);

         }).catch(res => {

         })
       }
     }
 }
</script>
<style>
</style>
